import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, Navigate } from "react-router-dom";

import { LocalStorage } from "./Utils";
import { useAppSelector } from "../store/hooks";

import Layout from "./../portal/Layout";

const ProtectedRoute = (props: any) => {
  const { roles, lastElement } = props;

  const { t } = useTranslation();
  let location = useLocation();
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkUserToken = () => {
    let userToken = sessionStorage.getItem("user-token");
    if (!userToken) {
      userToken = LocalStorage.get("user-token");
    }
    if (!userToken || userToken === "undefined" || userToken === null) {
      setIsLoggedIn(false);
      return navigate("/login");
    } else {
      setIsLoggedIn(true);
    }
  };

  useEffect(() => {
    checkUserToken();
  }, [isLoggedIn]);

  const { loginResponse, loading } = useAppSelector((state) => state.login);
  if (loading) {
    return <p>{t("loading")}</p>;
  }

  if (!loginResponse.token && lastElement) {
    return <Navigate to={"/login"} state={{ from: location }} />;
  }

  const loginType = LocalStorage.get("loginType");

  return (
    isLoggedIn &&
    loginType &&
    roles.includes(loginType) && (
      <>
        <Layout />
        {props.children}
      </>
    )
  );
};

export default ProtectedRoute;
